export const PRIVILEGES = {
  CHANGE_CODES: 'change_codes',
  GENERATION_OF_SUBSCRIPTION_FORMS: 'generation_of_subscription_forms',
  REQUEST_DIGITAL_PROFILE_FL: 'request_digital_profile_fl',
  REQUEST_NBKI_DATA: 'request_nbki_data',
  SENDING_ACT_TO_EDO: 'sending_act_to_edo', //Отправка акта в ЭДО
  SENDING_DOCUMENTS_TO_EDO: 'sending_documents_to_edo',
  RENAMING_APPLICATION_FILES: 'renaming_application_files',
  EDITING_A_DOCUMENT_TYPE: 'editing_a_document_type',
  ORIG_PROVIDED: 'orig_provided',
  REQUEST_FOR_ADD_DOCS: 'request_for_add_docs',
  ABS_CLIENT_STATUS: 'abs_client_status',
  SETTING_PROCESSING_TIME: 'setting_processing_time', //Изменение настроек отчета "Время обработки заявок"
};
